import { render } from "./MaxBotConnectionGuide.vue?vue&type=template&id=9c7a9b48&scoped=true"
import script from "./MaxBotConnectionGuide.vue?vue&type=script&lang=js"
export * from "./MaxBotConnectionGuide.vue?vue&type=script&lang=js"

import "./MaxBotConnectionGuide.vue?vue&type=style&index=0&id=9c7a9b48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c7a9b48"]])

export default __exports__